document.addEventListener("DOMContentLoaded", () => {
  const menuButton = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  menuButton?.addEventListener("click", () => {
    const open = mobileMenu.hasAttribute("hidden");
    mobileMenu.toggleAttribute("hidden", !open);
    menuButton.setAttribute("aria-expanded", String(open));
  });

  const grid = document.querySelector("[data-product-grid]");
  if (grid) {
    const cards = [...grid.querySelectorAll("[data-product-card]")];
    const filters = document.querySelectorAll("[data-filter]");
    const empty = document.querySelector("[data-empty-filter]");
    const count = document.querySelector("[data-results-count]");
    const applyFilter = (value) => {
      let shown = 0;
      cards.forEach((card) => {
        const haystack = `${card.dataset.type || ""},${card.dataset.tags || ""}`;
        const visible = value === "all" || haystack.includes(value);
        card.hidden = !visible;
        if (visible) shown += 1;
      });
      empty?.toggleAttribute("hidden", shown !== 0);
      if (count) count.textContent = `${shown} prodotti city-riding`;
    };
    filters.forEach((button) => button.addEventListener("click", () => {
      filters.forEach((item) => item.classList.remove("active"));
      button.classList.add("active");
      applyFilter(button.dataset.filter);
    }));
    document.querySelector("[data-sort-products]")?.addEventListener("change", (event) => {
      const direction = event.target.value;
      const sorted = [...cards].sort((a, b) => {
        if (direction === "price-asc") return Number(a.dataset.price) - Number(b.dataset.price);
        if (direction === "price-desc") return Number(b.dataset.price) - Number(a.dataset.price);
        return 0;
      });
      sorted.forEach((card) => grid.appendChild(card));
    });
  }

  const form = document.querySelector("[data-product-form]");
  if (form) {
    const variantData = form.querySelector("[data-product-variants]");
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const groups = [...form.querySelectorAll("[data-option-position]")];
    const selectedOptions = () => groups.map((group) => group.querySelector("[data-option-value].selected")?.dataset.optionValue || "");
    const updateVariant = () => {
      const chosen = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === chosen[index]));
      const hiddenId = form.querySelector("[data-variant-id]");
      const price = document.querySelector("[data-product-price]");
      const submit = form.querySelector(".add-to-cart");
      if (!variant) {
        if (hiddenId) hiddenId.value = "";
        submit.disabled = true;
        submit.textContent = "COMBINAZIONE NON DISPONIBILE";
        return;
      }
      hiddenId.value = variant.id;
      if (price) price.textContent = variant.price;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? `AGGIUNGI AL CARRELLO — ${variant.price}` : "ESAURITO";
    };
    form.querySelectorAll("[data-option-value]").forEach((button) => button.addEventListener("click", () => {
      const group = button.closest("[data-option-position]");
      group.querySelectorAll("[data-option-value]").forEach((item) => item.classList.remove("selected"));
      button.classList.add("selected");
      updateVariant();
    }));
    updateVariant();

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const status = form.querySelector("[data-product-status]");
      const submit = form.querySelector(".add-to-cart");
      const original = submit.textContent;
      submit.disabled = true;
      status.textContent = "Aggiunta al carrello…";
      try {
        const response = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        if (!response.ok) throw new Error("Impossibile aggiungere questo articolo.");
        const cart = await fetch("/cart.js").then((result) => result.json());
        document.querySelectorAll("[data-cart-count]").forEach((item) => { item.textContent = cart.item_count; });
        status.textContent = "Articolo aggiunto al carrello.";
        submit.textContent = "AGGIUNTO AL CARRELLO";
        setTimeout(() => { submit.textContent = original; }, 1800);
      } catch (error) {
        status.textContent = error.message;
      } finally {
        submit.disabled = false;
      }
    });
  }

  document.querySelector("[data-size-guide-open]")?.addEventListener("click", () => document.querySelector("[data-size-guide]")?.showModal());
  document.querySelector("[data-size-guide-close]")?.addEventListener("click", () => document.querySelector("[data-size-guide]")?.close());
});
